import * as React from "react"
const Margarine = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}>
    <path fill="#FFEA9F" d="M12 23V12h14v11H12Z" />
    <path fill="#F1CA3F" d="M6 23V12h6v11H6Z" />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M11.882 24H6V13h5.882m0 11V13m0 11H26V13H11.882"
    />
    <path
      fill="#E2E2E2"
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3.342 25.261A1 1 0 0 1 4.307 24h23.386a1 1 0 0 1 .965 1.261l-.541 2a1 1 0 0 1-.966.739H4.85a1 1 0 0 1-.966-.739l-.541-2ZM13.793 6.257l8.485 8.486a2 2 0 0 1-2.828 2.828l-1.06-1.06-2.476-2.475-2.475-2.475-.353-.354a3 3 0 0 1 0-4.243l.707-.707Z"
    />
    <path
      stroke="#010101"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M9.964 2.429 13.5 5.964l-.707.707-3.536-3.535zM14 13h3v2"
    />
    <path fill="#FFEA9F" d="M16 14h-3l3 3v-3Z" />
  </svg>
)
export default Margarine
